import { RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { QueryClientProvider } from "@tanstack/react-query";
import { router } from "./router";
import { Suspense } from "react";
import { Spinner } from "./assets/icons";
import { ErrorPage } from "./misc/error-page";
import "./App.css";
import { queryClient } from "./lib";

const fallback = (
  <div className='h-screen grid place-items-center'>
    <Spinner size={28} />
  </div>
);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary fallback={<ErrorPage />}>
        <Suspense fallback={fallback}>
          <RouterProvider router={router} />
        </Suspense>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
